import { Repository } from "@octopusdeploy/octopus-server-client";
import type { GitHubConnectionsPageLoaderData } from "~/areas/library/components/GitConnections/GitHubConnectionsPageInternal";
import { getNotConnectedInstallations, getAuthorizationStatus, GitHubConnectionsPageInternal } from "~/areas/library/components/GitConnections/GitHubConnectionsPageInternal";
interface GitHubConnectionsPageProps {
    spaceId: string;
    loaderData: GitHubConnectionsPageLoaderData;
}
export async function gitHubConnectionsPageLoader(repository: Repository): Promise<GitHubConnectionsPageLoaderData> {
    const connections = repository.GitHubApp.getConnections(0, Repository.takeAll);
    const authorizationStatus = await getAuthorizationStatus(repository);
    const notConnectedInstallations = await getNotConnectedInstallations(repository, authorizationStatus.IsAuthorized);
    return { connections: await connections, authorizationStatus, notConnectedInstallations };
}
export function GitHubConnectionsPage({ spaceId, loaderData }: GitHubConnectionsPageProps) {
    return <GitHubConnectionsPageInternal spaceId={spaceId} loaderData={loaderData}/>;
}
